export const DEMO_POLL_DATA = {
  succes: true,
  skin: 1,
  name: "Encuesta Demo",
  pollId: "demo",
  questions: [
    {
      questionId: 1,
      question: "¿Sabía usted que la ciudad cuenta con nuevos programas de apoyo?",
      type: 1,
      answers: [
        { description: "demo-1.jpg", answerId: 1, answer: "Sí" },
        { description: "demo-1.jpg", answerId: 2, answer: "No" },
      ],
    },
    {
      questionId: 2,
      question: "¿Conocía los servicios digitales del gobierno municipal?",
      type: 1,
      answers: [
        { description: "demo-2.jpg", answerId: 1, answer: "Sí sabía" },
        { description: "demo-2.jpg", answerId: 2, answer: "No sabía" },
      ],
    },
  ],
};
